module.exports = __webpack_public_path__ + "img/8.fc437477.png";